import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';

import { MatCheckbox } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';
import {
  BookingDashboardDevice,
  BookingService,
  Platform,
  getDevicePlatformBasingOnRoles,
} from '@store';
import { matTooltipSetter } from '../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-bookable-installation',
  templateUrl: './bookable-installation.component.html',
  styleUrls: ['./bookable-installation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookableInstallationComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() device: BookingDashboardDevice;
  @Input() invoiceNumber: string;
  @Input() isDisabled: boolean;
  @Input() isSelected: boolean;
  @Input() isVoucherAvailable?: boolean;

  @Output() select = new EventEmitter<void>();

  tooltipForNonBookableInstallation: string;
  deviceTitle: string;

  constructor(private bookingService: BookingService) {}

  ngOnInit(): void {
    if (this.isDisabled) {
      this.tooltipForNonBookableInstallation = this.getTranslationKeyForNonBookableInstallation();
    }
    this.deviceTitle = this.bookingService.getDeviceTitle(this.device);
  }

  protected onInstallationSelect(checkbox: MatCheckbox): void {
    checkbox.toggle();
    this.select.emit();
  }

  private getTranslationKeyForNonBookableInstallation(): string {
    const { roles, vin, plan } = this.device;
    const platform = getDevicePlatformBasingOnRoles(roles);

    if (!vin) {
      return '+BOOKING.DEVICES.MISSING_BOILER_SERIAL_TOOLTIP';
    }

    if (this.invoiceNumber) {
      if (plan === SubscriptionPlan.Plus) {
        return '+BOOKING.DEVICES.TOOLTIP.PLUS_PACKAGE';
      }

      if (!this.device.canBeBundled) {
        return '+BOOKING.DEVICES.NOT_PART_OF_BUNDLING_WHITELIST_TOOLTIP';
      }
    }

    if (plan === SubscriptionPlan.Plus) {
      return '+BOOKING.DEVICES.TOOLTIP.PLUS_TO_PRO';
    }

    if (platform === Platform.None) {
      return '+BOOKING.DEVICES.TOOLTIP.OFFLINE_INSTALLATION';
    }

    if (this.isVoucherAvailable) {
      return '+BOOKING.DEVICES.TOOLTIP.VOUCHER';
    }

    return '+BOOKING.DEVICES.NOT_PART_OF_WHITELIST_TOOLTIP';
  }
}
